const API_BASE_URL = "https://alcobrakeadmin.com/v3/us";

export const technicianAPI = {
  // Fetch all users
  fetchUsers: async () => {
    const url = `${API_BASE_URL}/causers/getallusers`;
    
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      return data || [];
    } catch (error) {
      console.error("Error fetching users:", error);
      throw error;
    }
  },

  // Fetch users for a specific dealer
  fetchDealerUsers: async (dealerId) => {
    const url = `${API_BASE_URL}/causers/getdealerusers?dealerName=${dealerId}`;
    
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      
      const data = await response.json();
      return data || [];
    } catch (error) {
      console.error("Error fetching dealer users:", error);
      throw error;
    }
  },

  // Add new user
  addUser: async (userData) => {
    const url = `${API_BASE_URL}/causers/adduser`;
    
    const formData = new FormData();
    formData.append("userName", userData.userName || "");
    formData.append("userEmail", userData.userEmail || "");
    formData.append("userMobile1", userData.userMobile1 || "");
    formData.append("userMobile2", userData.userMobile2 || "");
    formData.append("accesslevel", userData.accesslevel || "Technician");
    formData.append("dealer", userData.dealer || "");
    formData.append("userPassword", userData.userPassword || "");
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error adding user:", error);
      throw error;
    }
  },

  // Edit user
  editUser: async (userId, userData) => {
    const url = `${API_BASE_URL}/causers/edituser/${userId}`;
    
    const formData = new FormData();
    formData.append("userName", userData.userName || "");
    formData.append("userEmail", userData.userEmail || "");
    formData.append("userMobile1", userData.userMobile1 || "");
    formData.append("userMobile2", userData.userMobile2 || "");
    formData.append("accesslevel", userData.accesslevel || "Technician");
    formData.append("dealer", userData.dealer || "");
    
    if (userData.userPassword) {
      formData.append("userPassword", userData.userPassword);
    }
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      
      const responseText = await response.text();
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error editing user:", error);
      throw error;
    }
  },

  // Delete user
  deleteUser: async (userId) => {
    const url = `${API_BASE_URL}/causers/deleteuser/${userId}`;
    
    try {
      const response = await fetch(url, {
        method: 'GET',
      });
      
      const responseText = await response.text();
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status} - ${responseText}`);
      
      let data;
      try {
        data = JSON.parse(responseText);
      } catch (e) {
        data = responseText;
      }
      return data;
    } catch (error) {
      console.error("Error deleting user:", error);
      throw error;
    }
  },
};